export class GridLayoutColumn {
  fieldId!: string;
  isFixed!: boolean;
  width?: number;
}
